import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { urls } from "./urls";

export function getAccessToken() {
  return localStorage.getItem("access");
}

// Function that will be called to refresh authorization
const refreshAuthLogic = async (failedRequest) => {
  const refreshToken = await localStorage.getItem("refresh");
  await axios
    .post(urls.TOKEN_REFRESH, {
      refresh: refreshToken,
    })
    .then(async (tokenRefreshResponse) => {
      await localStorage.setItem("access", tokenRefreshResponse.data.access);
      failedRequest.response.config.headers["Authorization"] =
        "Bearer " + tokenRefreshResponse.data.access;
      return Promise.resolve();
    });
};

// Instantiate the interceptor (you can chain it as it returns the axios instance)
export const apiConfig = axios.create({
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    // Authorization: "Bearer " + localStorage.getItem("access"),
  },
});

apiConfig.interceptors.request.use((request) => {
  request.headers["Authorization"] = `Bearer ${getAccessToken()}`;
  return request;
});

createAuthRefreshInterceptor(apiConfig, refreshAuthLogic, {
  skipWhileRefreshing: true,
});
